import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="search-filter"
export default class extends Controller {
  static targets = ["search", "checkbox"]

  connect() {
    this.searchTarget.addEventListener("input", this.filter.bind(this))
    this.filter() // Initial filter on connect
  }

  filter() {
    const searchTerm = this.searchTarget.value.toLowerCase()
    
    this.checkboxTargets.forEach(checkbox => {
      const checkboxContainer = checkbox.closest(".checkbox")
      const label = checkboxContainer.querySelector("label").textContent.toLowerCase()

      if (label.includes(searchTerm) || searchTerm === "") {
        checkboxContainer.style.display = "" // Show the checkbox
      } else {
        checkboxContainer.style.display = "none" // Hide the checkbox
      }
    })
  }

  clear(event) {
    event.preventDefault()
    this.searchTarget.value = ""
    this.filter()
  }
}
